import { EventDefinition } from 'redux-beacon'
import { UploadEndEvent } from '../actions/upload'
import { getCharacterCount, getFileExtension, getWordCount } from '../util/helpers'
import { EVENT_TYPES, PAPER_UPLOAD_STATES, PAGE_TYPE } from './constants'

export const uploadStartEvent: EventDefinition = action => {
  return {
    type: EVENT_TYPES.PAPER_UPLOAD,
    data: {
      state: PAPER_UPLOAD_STATES.start,
    },
  }
}

export const uploadEndEvent: EventDefinition = action => {
  const { uploadId, text, filename } = action.payload as UploadEndEvent
  const wordCount = getWordCount(text)
  const characterCount = getCharacterCount(text)
  const fileType = getFileExtension(filename)
  return {
    type: EVENT_TYPES.PAPER_UPLOAD,
    data: {
      state: PAPER_UPLOAD_STATES.end,
      uploadId,
      wordCount,
      characterCount,
      fileType,
    },
  }
}

// add a page view event here
export const pageViewEvent: EventDefinition = action => ({
  type: EVENT_TYPES.PAGEVIEW,
  pageType: PAGE_TYPE,
})
